import type { RealestateAsset } from "~/types/assets.types";
import type { Fiat } from "~/types/global.types";
import { calculateRealestateNetBalance } from "./balance";
import { calculateRealestateNetMonthlyCashflowWithTax } from "./netMonthlyCashflow";
import { calculateRealestatePurchaseExpenses } from "./purchaseExpenses";
import { calculateRealestateYears } from "./years";
import { convertCurrency } from "../genericCalculations/convertCurrency";

export const calculateRealestateCurrentYield = (
  userProduct: RealestateAsset,
  currencies: { baseCurrency: Fiat; currentCurrency: Fiat }
) => {
  const { baseCurrency, currentCurrency } = currencies;
  const netBalance = calculateRealestateNetBalance(
    userProduct,
    baseCurrency,
    currentCurrency
  );

  const netMonthlyFlow = calculateRealestateNetMonthlyCashflowWithTax(
    userProduct,
    baseCurrency,
    currentCurrency
  );
  const expensesBase = calculateRealestatePurchaseExpenses(userProduct);
  const expenses = convertCurrency(expensesBase, baseCurrency, currentCurrency);
  const years = calculateRealestateYears(userProduct);

  if (Number(expenses) === 0 || Number(years) === 0) return 0;
  return (
    ((((Number(netBalance) +
      Number(netMonthlyFlow) * 12 * Number(years) )
      / Number(expenses))  - 1) / Number(years)) 
  )
};
